/* eslint-disable i18next/no-literal-string */
/* eslint-disable no-nested-ternary */
import { Button } from '@material-ui/core'
import clsx from 'clsx'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Separator from '@flatsy/core/Layout/Separator'
import { Body1, Body2, Body3, Header1 } from '@flatsy/core/MaterialUi/Typo'
import { toNameCase } from '@flatsy/core/MaterialUi/Typo/Utile'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import { isPublicAssetFromLamyNetwork } from '@flatsy/utils/Functions/Assets'
import i18n from '@flatsy/utils/translations'
import { FormContext, ReturnContextProps } from 'src/containers/Qualification/Context'
import { useApplicationBooking } from 'src/hooks/ApplicationBooking'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { useMobile } from 'src/hooks/Mobile'
import { applicationSlice, selectApplicationState } from 'src/redux/slices/Application'

import { useFormStyles } from '../../Style'
import useStyle from './Style'
import { asBooking, renderBookingAddress, renderBookingDate } from './Utils'

const Success: React.FC = (): React.ReactElement => {
  const classes = useStyle()
  const isMobile = useMobile()
  const dispatch = useDispatch()
  const formClasses = useFormStyles()
  const {
    application: { application },
    asset,
    qualification,
  } = useApplicationDetails()
  const { booking } = useApplicationBooking({ applicationId: application.id })
  const { inWaitingList } = useContext(FormContext) as ReturnContextProps
  const [active, setActive] = useState(false)
  const applicationState = useSelector(selectApplicationState)

  useEffect(() => {
    setTimeout(() => {
      setActive(true)
    }, 60)
  }, [])

  const handleGoToApplication = () => {
    dispatch(applicationSlice.actions.setJustCompletedToFalse())
  }

  return (
    <div className={formClasses.container}>
      <div className={classes.wrapper}>
        <img
          alt="ballon"
          src={FlatsyTheme.image.qualification.ballon1}
          className={clsx(classes.ballon1, active && classes.ballonActive)}
        />
        <img
          alt="ballon"
          src={FlatsyTheme.image.qualification.ballon2}
          className={clsx(classes.ballon2, active && classes.ballonActive)}
        />
        <img
          alt="ballon"
          src={FlatsyTheme.image.qualification.ballon3}
          className={clsx(classes.ballon3, active && classes.ballonActive)}
        />
        <div className={clsx(classes.inner, active && classes.innerActive)}>
          <img
            alt="success"
            src={FlatsyTheme.image.qualification.success}
            className={clsx(classes.successImage, active && classes.successActive)}
          />
          <Header1 align="center" lowerCase>
            {inWaitingList
              ? i18n.t('request_successfully_recorded')
              : i18n.t('confirmation_of_your_appointment')}
          </Header1>
          <Separator size="24px" />
          <Body2 align="center">
            {inWaitingList
              ? i18n.t('contact_from_representative')
              : i18n.t(
                  'the_scheduling_of_an_appointment_is_subject_to_the_accuracy_of_the_information_previously_provided'
                )}
          </Body2>
          <Separator size="24px" />
          <div className={isMobile ? classes.column : classes.row}>
            <Body1>{inWaitingList ? i18n.t('applicant_for') : i18n.t('property_tour_for')} </Body1>
            <Body3>
              {`${toNameCase(applicationState.application.lead?.first_name) || ''} ${
                toNameCase(applicationState.application.lead?.last_name) || ''
              }`}
            </Body3>
          </div>
          <div className={isMobile ? classes.column : classes.row}>
            <Body1>{i18n.t('address')}</Body1>
            <Body3>{renderBookingAddress(applicationState, asset)}</Body3>
          </div>
          {!inWaitingList && (
            <div className={isMobile ? classes.column : classes.row}>
              {(renderBookingDate(booking) || asBooking(applicationState)) && (
                <>
                  <Body1>{i18n.t('date_and_time')}</Body1>
                  <Body3>{renderBookingDate(booking) || asBooking(applicationState)}</Body3>
                </>
              )}
            </div>
          )}
          <div className={isMobile ? classes.column : classes.row}>
            <Body1>{i18n.t('real_estate_agent')}</Body1>
            <Body3>
              {`${toNameCase(applicationState.application.agent?.first_name) || ''} ${
                toNameCase(applicationState.application.agent?.last_name) || ''
              }`}
            </Body3>
          </div>
          <div className={classes.border} />
          <Separator size="24px" />
          {!asset?.is_sale &&
            !application?.is_verlingue_supported &&
            qualification?.need_uploads && (
              <Body1 align="center">
                {inWaitingList
                  ? i18n.t('prepare_rental_application_today')
                  : i18n.t(
                      'you_may_continue_the_application_process_by_clicking_on_the_button_below'
                    )}
              </Body1>
            )}
          {!inWaitingList && !asset?.is_address_full && !application?.is_verlingue_supported && (
            <>
              <Separator size="24px" />
              <Body1 align="center">
                {i18n.t('exact_address_will_be_given_2_hours_prior_to_the_tour')}
              </Body1>
            </>
          )}
          {application?.is_verlingue_supported && (
            <>
              <Separator size="24px" />
              <Body1 align="center">
                {i18n.t(
                  'to_finalise_the_solvency_assessment_of_your_application_our_secure_file_certification_service_will_send_you_an_e-mail_shortly_after_your_viewing'
                )}
              </Body1>
            </>
          )}
          <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.button}
            onClick={handleGoToApplication}
          >
            {i18n.t('proceed_to_the_application_space')}
          </Button>
        </div>
        {isPublicAssetFromLamyNetwork(asset) && (
          <div
            style={{ width: '100%' }}
            className={clsx(classes.inner, active && classes.innerActive)}
          >
            <div style={{ textAlign: 'center' }}>
              <Separator size="24px" />
              <p>
                LAMY en sa qualité de responsable de traitement, collecte et réalise des traitements
                de données à caractère personnel dans le cadre de la commercialisation de biens à
                louer comprenant notamment l’étude de dossier de candidat locataire et la relation
                contractuelle qui découle de cette sélection. Ces traitements sont fondés sur la
                base de votre consentement préalable.
              </p>
              <p>
                Les données collectées sont destinées aux services concernés de LAMY et plus
                généralement du Groupe EVORIEL et le cas échéant à ses sous-traitants et
                prestataires. Ces derniers sont soumis à une obligation de confidentialité et ne
                peuvent utiliser vos données qu’en conformité avec nos dispositions contractuelles
                et la législation applicable.
              </p>
              <p>
                Les données collectées sont susceptibles d’être conservées pendant une durée qui ne
                saurait excéder la durée de la relation contractuelle augmentée de toute
                prescription légale et pour les demandes commerciales, pendant une durée de 3 ans à
                compter du dernier contact.
              </p>
              <p>
                Vous avez la possibilité d’exercer vos droits pour accéder, rectifier, effacer vos
                données, limiter leurs traitements, vous y opposer et demander la portabilité de
                celles-ci en suivant la procédure prévue sur le lien
                https://app.witik.io/fr/form/lamy/formulaire-rgpd ou par courrier postal à
                l’attention du Délégué à la Protection des données – LAMY – 19 rue de Vienne – TSA
                10034 – 75801 PARIS Cedex 08, accompagné d’une copie d’un titre d’identité.
              </p>
              <p>
                Vous pouvez également adresser une réclamation auprès de la Commission Nationale de
                l’informatique et des liberté – 3 place de Fontenoy – TSA 80715 – 75334 PARIS Cedex
                08.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Success
